import styled from 'styled-components'
import Icon from '@mdi/react'

import { WhiteBlock } from 'components/Layout'
import theme from 'theme_'
import CommonLinkButton from 'components/Button/CommonLinkButton'
import { Font12 } from 'components/Typography'

export const JobImageBlockContainer = styled(WhiteBlock)`
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  gap: ${theme.spacing.xs};
`

export const JobImageModalContainer = styled(WhiteBlock)`
  justify-content: center;
  align-items: center;
  padding: 0;
  padding-top: 32px;
`

export const JobImage = styled.img`
  width: 100%;
  height: 120px;
  background-color: ${theme.colors.beachGrey};
  border-radius: 8px;
  object-fit: cover;
  cursor: pointer;
`

export const JobModalImage = styled.img`
  max-width: 100%;
  max-height: 80vh;
  background-color: ${theme.colors.beachGrey};
  object-fit: contain;
`

export const JobImageSpinnerWrapper = styled.div`
  padding: 24px;
`

export const JobImageBottomBlock = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${Font12};
`

export const JobImageDeleteButton = styled(CommonLinkButton)`
  display: flex;
  padding: 0;
`

export const JobImageErrorIcon = styled(Icon)`
  width: 100%;
  height: 120px;
  color: ${theme.colors.beachGrey};
`

export const JobImageDeleteIcon = styled(Icon)`
  height: 20px;
  width: 20px;
  color: ${theme.colors.horizonOrange};

  :hover {
    cursor: pointer;
    opacity: 0.8;
  }
`
